export default function initCarousel () {
  // Where to buy
  $('#brand-carousel').owlCarousel({
    loop: false,
    responsiveClass: true,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 2
      },
      1000: {
        items: 3
      }
    }
  });

  // Mobile Product/POI images
  $('#mobile-product-images, #mobile-poi-images').owlCarousel({
    loop: false,
    nav: false,
    items: 2,
    dotsEach: true,
    stagePadding: 10,
    margin: 10,
    responsiveClass: true
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/product/carousel.js